// Colocated Driver.js tour for the Manage Receipts page, targeted at
// users with the manage-receipts permission (super admins and
// accountants). Four steps: what the page is for, how to filter,
// how to review a single receipt, and the accountability rule that
// stops a reviewer from approving their own upload.

export const MANAGE_RECEIPTS_OVERVIEW_TOUR_ID = 'manage-receipts-overview-v1';

export const buildManageReceiptsOverviewTourSteps = () => [
    {
        element: '[data-tour="manage-receipts-card"]',
        title: 'Sign off on receipts your team uploads',
        description: 'Every payment that has a receipt attached lands here for a second pair of eyes. Approve the ones that match; reject the ones that do not, with a reason the uploader can see.',
        side: 'bottom',
        align: 'center',
    },
    {
        element: '[data-tour="manage-receipts-filters"]',
        title: 'Narrow the list',
        description: 'Search on the mpesa code, amount, expense tag, or uploader name. Narrow by a date range. Flip the status filter between Pending, Approved, and Rejected, or leave it on All statuses.',
        side: 'bottom',
        align: 'start',
    },
    {
        element: '[data-tour="manage-receipts-list"]',
        title: 'Open a receipt to review it',
        description: 'The eye icon opens the receipt image or PDF alongside the amount, date, MPESA code, and uploader. Pick Approve or Reject, add a reason for a rejection, and confirm. The uploader gets an email either way.',
        side: 'top',
        align: 'center',
    },
    {
        element: '[data-tour="manage-receipts-card"]',
        title: 'Accountability: someone else signs off',
        description: 'You cannot review a receipt you uploaded yourself. The submitter and the reviewer are always two different people, regardless of role. Another super admin or accountant on your account has to approve your uploads, and you approve theirs.',
        side: 'bottom',
        align: 'center',
    },
];
